import actions from './actions';

const initState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.SEARCH_HOME_DELIVERY_ORDERS:
    case actions.SEARCH_HOME_DELIVERY_ORDERS_ENDED:
      return {
        ...state,
        isSearching: true,
      };
    case actions.FIND_HOME_DELIVERY_ORDER:
    case actions.FIND_HOME_DELIVERY_ORDER_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_HOME_DELIVERY_ORDER:
    case actions.BATCH_UPDATE_HOME_DELIVERY_ORDER:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_HOME_DELIVERY_ORDER_END:
    case actions.BATCH_UPDATE_HOME_DELIVERY_ORDER_END:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
}
